import { GLServiceBase } from 'gl-commonui'
import { injectable } from '../../../util/di'
import { IRoleService, RoleRequest, RolePagingRequest } from './index';

@injectable()
export class RoleService extends GLServiceBase<RoleRequest, RolePagingRequest> implements IRoleService {
    serviceRoute = { prefix: 'account/v1/roles', suffix: '{id}' }
}